import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PageHeader1 from '../../components/common/PageHeader1';
import Course from '../../components/Course/CourseAddEdit';
import TrackStepper from '../../components/Stepper/TrackStepper';
import { fetchCourse } from '../../Redux/Reducers/CourseReducer';

function CourseAdd() {
    const { id } = useParams();  
    const location = useLocation();
    const dispatch = useDispatch();
    const course = useSelector((state) => state.CourseReducer?.course?.data);
    
    const isEditing = location.pathname.includes('course-edit');

    const [steps, setSteps] = useState(0);
    const [currentStep, setCurrentStep] = useState(0);

    useEffect(() => {
        if (id) {
            dispatch(fetchCourse(id));  
        }
    }, [dispatch, id]);

    useEffect(() => {
        if (isEditing && course) {
            const draftStep = course?.isDraft ? course?.step : 0; 
            setSteps(draftStep);
            setCurrentStep(draftStep);
        }
    }, [isEditing, course]);

    const handleSteps = (newStep, type) => {
        if (type === 'step') {
            if (newStep <= currentStep) {
                setSteps(newStep);
            }
        } else {
            setSteps(newStep);
            setCurrentStep(newStep);
        }
    };

    return (
        <div className="body d-flex py-lg-3 py-md-2">
            <div className="container-xxl">
            <button
                onClick={() => window.history.back()}
                style={{
                    marginBottom: "10px",
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontFamily: "monospace",
                    fontSize: "18px",
                    color: "#007bff",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    padding: "10px 20px",
                }}
            >
                <span style={{ marginRight: "8px" }}>&lt;</span>
                <span style={{ position: "relative", display: "inline-block" }}>
                    Back
                    <span
                        style={{
                            content: "''",
                            position: "absolute",
                            left: 0,
                            bottom: -2,
                            width: "100%",
                            height: "1px",
                            borderBottom: "2px solid #007bff",
                        }}
                    ></span>
                </span>
            </button>
                <PageHeader1 
                    pagetitle={isEditing ? 'Edit Course' : 'Add Course'} 
                />
                <div className="row clearfix g-3">
                    <div className="col-lg-12">
                        <TrackStepper steps={steps} handleSteps={handleSteps} />
                    </div>
                    <div className="col-lg-12">
                        <Course
                            handleSteps={handleSteps}
                            steps={steps}
                            setCurrentStep={setCurrentStep}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CourseAdd;

